window.AMSAPI = new function () {

    var eventHandlers = {
        'filterApplied': []
    };


    var self = this;
    var _protected = BaseAPI.call(self);
    const MAX_SEARCH_LIMIT = 9999;

    self.onFilterApplied = function (eventHandler) {
        eventHandlers['filterApplied'].push(eventHandler);
    };

    self.getLocationsDetails = function (jobId) {
        var defer = $q.defer();

        _protected.request("ams_buckets_admins/" + jobId, "GET").then(function (res) {
            if (res.data && res.data.data && res.data.data.locations) {
                defer.resolve(res.data.data.locations);
            }
            else {
                defer.reject();
            }
        });

        return defer.promise;
    };

    self.getSBMLBrandLocations = function (brand_id) {
        var defer = $q.defer();

        _protected.request("sbml_ams/brand_locations/" + brand_id, "GET").then(function (res) {
            if (res.data && res.data.data) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject();
            }
        });

        return defer.promise;
    };

    self.downloadCandidatesCvs = function (brandId, jobId, bucketId, applicationIds) {
        var defer = $q.defer();

        var params = {
            bucket_code: bucketId,
            application_ids: applicationIds
        };
        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/applications/resumes/download', 'POST', params)
            .then(function (result) {
                defer.resolve(result);
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBucketsStats = function (jobID, doorID) {
        var defer = $q.defer();

        var query_string = "";

        if (doorID) {
            query_string = "?door_id=" + doorID;
        }
        const v2Url = self.apiUrl.replace('v1', 'v2');
        _protected.request(v2Url+`ams_buckets/${jobID}${query_string}`, "GET").then((res) => {
            if (res.data.status_code == 403) {
                defer.resolve('NOT_AUTHORISED');
            } else {
                defer.resolve(res.data.data);
            }
        });

        return defer.promise;
    }

    // Formate a brand for the jobs/brands menu list
    // Recursive ??
    // TODO: Avoid recursion (recursion is a critical performance issue in JS)
    var formatBrand = function (item) {
        var brand = {};
        brand.id = item.Brand[0].Brand.id;
        brand.name = item.Brand[0].Brand.name;
        brand.app_count = 0;
        brand.jobs = [];
        brand.is_archived = item.Brand[0].Brand.is_archived;
        if (item.Brand[0].Brand.BrandMedia) {

            brand.media = _.findWhere(item.Brand[0].Brand.BrandMedia, {'type': 'profile_image'});
        }
        _.each(item.jobs, function (job) {
            brand.jobs.push({
                'job_id': job.Job.id,
                'position': job.Job && job.Job.alias_position ? job.Job.alias_position : job.Position.name,
                'app_count': job.hasOwnProperty('new_applications_count') ? job.new_applications_count : 0,
                'total_app_count': job.hasOwnProperty('total_applications_count') ? job.total_applications_count : 0
            });

            if (job.hasOwnProperty('new_applications_count')) {
                brand.app_count += job.new_applications_count;
            }
        });

        var children = [];
        item.Children = item.Children || [];

        item.Children.forEach(function (child) {
            children.push(formatBrand(child))
        });

        brand.children = children;

        return brand;
    };

    self.getUserBrandsJobs = function (groupId, withTotalApplicationsCount) {
        var defer = $q.defer();
        var optionalParameter = "";

        if (withTotalApplicationsCount) {
            optionalParameter = "?total_applications_count=true";
        }

        _protected.request("groups/" + groupId + "/ams_brands" + optionalParameter, "GET").then(function (res) {

            var brands = [];

            res.data.data.forEach(function (item) {
                brands.push(formatBrand(item));
            });


            defer.resolve(brands);
        });

        return defer.promise;
    };

    self.getInterviewsBrandsJobs = function (groupId) {
        var defer = $q.defer();

        _protected.request("groups/" + groupId + "/jobs_of_brands", "GET").then(function (res) {

            var brands = [];

            res.data.data.forEach(function (item) {
                brands.push(formatBrand(item));
            });


            defer.resolve(brands);
        });

        return defer.promise;
    };

    self.moveApplicant = async (source, destination, apps, duplicate, preventNotifyCandidates) => {
        let data = {};
        data['destination_job_id'] = destination;
        data['application_ids'] = apps;
        data['prevent_notify_candidates'] = preventNotifyCandidates;

        const res = await _protected.request(`jobs/${source}/applications/move?duplicate=${!!duplicate}`, 'POST', data);

        if (res?.status === 200 && res?.data?.data) {
            return res.data.data;
        } else {
            throw res;
        }
    };


    self.getOrPostCards = function (job_id, options) {

        var isGet = true;
        var queryKeys = Object.keys(options);
        var onlyGetParams = ['job_id', 'door_id', 'limit', 'offset', 'buckets', 'include_archived'];

        options = options || {};
        options['job_id'] = job_id;

        for (var i = 0; i < queryKeys.length; i++) {
            var param = queryKeys[i];
            if (onlyGetParams.indexOf(param) == -1) {
                isGet = false;
                break;
            }
        }

        // post doesn't accept string of buckets
        if (!isGet && options['buckets'] && !Array.isArray(options['buckets'])) {
            options['buckets'] = [options['buckets']];
        }

        return ( isGet ) ? self.loadCards(job_id, options) : self.searchCards(job_id, options);
    };

    self.loadCards = function (job_id, options) {
        var defer = $q.defer();
        options = options || {};
        options['job_id'] = job_id;
        loadCards(options).then(function(data){

            /*
             sort intervew candidates by :
             1- Candidates without an invitation, sorted based on the move action date time (recently dragged will appear at the top)
             2- Confirmed interviews, chronologically sorted based on the confirmed time.
             3- Pending interviews, chronologically sorted based on the invitation sent date time.
             4- Rejected interviews, chronologically sorted based on the reject action date time.
             */

            var interviewStatusOrder = ["Confirmed", "Sent", "Denied"];

            if (data["Interview"] && data["Interview"].locations) {
                for (var location_id in data["Interview"].locations) {

                    var getCandidateSortWeight = function (candidate) {
                        var interview = (candidate.schedule_date && candidate.schedule_date[0]) || {};
                        var dateForSorting = 0;
                        if (interview && interview.status) {
                            if (interview.JobScheduleSlots) {
                                // revert the date so if we compared 2PM and 1PM, 1PM must be before. so this line handle that case.
                                dateForSorting = 9000000000000 - (new Date(interview.JobScheduleSlots.start_time).getTime());
                            }
                            else {
                                dateForSorting = new Date(interview.updated).getTime();
                            }
                        }
                        return (interviewStatusOrder.length - interviewStatusOrder.indexOf(interview.status)) + "_" + dateForSorting;
                    };

                    data["Interview"].locations[location_id].candidates =
                        data["Interview"].locations[location_id].candidates.sort(function (candidate1, candidate2) {
                            return getCandidateSortWeight(candidate1) < getCandidateSortWeight(candidate2) ? 1: -1;
                        });
                }

            }
            defer.resolve(data);
        }, function (error) {
            defer.reject(error);
        });
        return defer.promise;
    };

    self.searchCards = function (job_id, options) {
        options = options || {};
        options['job_id'] = job_id;

        if (options.limit) {
            // Work around to solve AMS filtering (search) pagination ordering issue
            options.limit = MAX_SEARCH_LIMIT;
        }

        if (options.offset) {
            options.limit = MAX_SEARCH_LIMIT - options.offset;
        }

        triggerEvent('filterApplied', options);

        return loadCards(options, "POST");
    };

    var loadCards = function (options, method) {

        method = method || "GET";
        options = options || {};

        var defer = $q.defer();

        var DEFAULT_OPTS = {
            "job_id": options['job_id']
        };

        if (!options.ids_only) {
            DEFAULT_OPTS['limit'] = 10; // server maximum limit is 50
        }

        options = $.extend(DEFAULT_OPTS, options);

        if (method == "GET" && typeof(options.buckets) === 'object') {
            options.buckets = options.buckets.join(",");
        }

        var apiPath = "ams_candidates";

        if (options.ids_only) {
            apiPath = apiPath + "_ids";
        }

        _protected.request(apiPath + "/" + options['job_id'], method || "GET", options)
            .then(function (res) {
                if (res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res && res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    /**
     * Save AMS Settings in BE, including cols visibility to admins and managers
     */
    self.saveAMSSettings = function (jobId, affectedBuckets, locations) {
        var defer = $q.defer();

        var data = {
            doors_visibility_settings: {
                doors: [],
                buckets: affectedBuckets
            },
            buckets_visibility_settings: {
                doors: [],
                buckets: affectedBuckets
            }
        };

        for (var location_id in locations) {
            var location = locations[location_id];

            data['doors_visibility_settings'].doors.push({
                door_id: location_id,
                visibility: (location.isVisibleToAdmin ? 1 : 0)
            });

            data['buckets_visibility_settings'].doors.push({
                door_id: location_id,
                visibility: (location.isVisibleToChildren ? 1 : 0)
            });
        }

        _protected.request("ams/settings/" + jobId, "POST", data)
            .then(function (res) {
                res = res.data;

                if (res.status_code == 200) {
                    defer.resolve();
                }
                else {
                    defer.reject(res);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.moveCards = function (jobId, appIdsGroup, toState) {
        var defer = $q.defer();

        var data = {
            job_id: jobId,
            applicants: []
        };

        var orderIndex = 0;

        for (var i = 0; i < appIdsGroup.length; i++) {
            for (var j = appIdsGroup[i].length - 1; j >= 0; j--) {
                var cardData = {
                    order: (toState.indices[orderIndex++]),
                    bucket_id: toState.bucket,
                    application_id: appIdsGroup[i][j].app_id
                };

                if (toState.location != AMSAPI.GENERIC_LOCATION) {
                    cardData.door_id = toState.location;
                }

                data.applicants.push(cardData);
            }
        }

        data.applicants.reverse();

        _protected.request("job_applications/move", "POST", data)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    defer.resolve(res);
                } else {
                    defer.reject(res && res.data && res.data.data);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getJobDoors = function (job_id) {
        var defer = $q.defer();
        _protected.request('job_doors/' + job_id, 'GET').then(function (res) {
            defer.resolve(res.data);
        });
        return defer.promise;
    };

    self.getInterviewLocations = function (brand_id) {
        var defer = $q.defer();

        _protected.request('interview/brand_locations/' + brand_id, 'GET').then(function (res) {
            res = res.data;

            if (res && res.data && typeof(res.data) == "object") {
                defer.resolve(res.data);
            }
            else {
                defer.reject(res);
            }
        });

        return defer.promise;
    };

    self.getCardHistory = function (appId, jobId, prospectId) {
        var defer = $q.defer();

        var data = {};

        if (appId && jobId) {
            data.application_id = appId;
            data.job_id = jobId;
        } else if (prospectId) {
            data.prospect_id = prospectId;
        } else {
            console.error("(AppId and JobId) or prospectId are required");
            return;
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospect_audit', 'GET', data)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200 && res.data.data) {
                    var actions = res.data.data.actions || [];
                    defer.resolve(actions);
                }
                else {
                    defer.reject(res);
                }
            },
            function (err) {
                console.error(err);
                defer.reject(err);
            });

        return defer.promise;
    };

    /**
     * Move Prospect to Hire
     * @param prospectId
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.moveProspectToHired = function (payload, prospect) {
        var deferred = $q.defer();

        var requestPayload = payload;

        if(typeof(prospect) === 'object'){
            requestPayload.prospect = prospect;
        }else{
            requestPayload.prospect_id = prospect;
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospect/move_to_hired', 'PUT', requestPayload)
            .then(function(res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    /**
     * Gets all applications history for this user
     * @param brandId
     * @param applicationId
     * @returns {deferred.promise|{then, always}}
     */
    self.getApplicationHistory = function (jobId, candidateId,  applicationId) {
        var deferred = $q.defer();

        var params = {
            job_id: jobId,
            candidate_id: candidateId,
            current_application_id: applicationId
        };


        _protected.request('job_applications/history', 'GET', params)
            .then(function(res) {

                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getCandidateDigitalApplicationLink = function (jobId, candidateId) {
        var defer = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'digital_application/pdf_signed_link/' + jobId + '/' + candidateId, 'GET').then(function (res) {
            if (res.data && res.data.data && res.data.data.link) {
                defer.resolve(res.data.data.link);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    /**
     * Gets all applications history for this user
     * @param candidateId
     * @param brandId
     * @returns {deferred.promise|{then, always}}
     */
    self.getApplicationHistoryNoJob = function (candidateId,  brandId) {
        var deferred = $q.defer();

        var params = {
            brand_id: brandId,
            candidate_id: candidateId,
        };


        _protected.request('job_applications/history', 'GET', params)
            .then(function(res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getApplicants = function (jobId, appIds) {
        var deferred = $q.defer();

        var params = {
            job_id: jobId,
            job_application: appIds
        };

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'speedyScreen/applications', 'POST', params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getAMSSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('/brands/' + brandId + '/ams/settings', 'GET')
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getPreviousApplications = function (brandId, jobId, applicationId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!jobId) {
            throw "No job id";
        }

        if (!applicationId) {
            throw "No application id";
        }

        _protected.request('/brands/' + brandId + '/jobs/' + jobId + '/applications/' + applicationId + '/previous_applications', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(angular.copy(res.data.data));
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Trigger an event with all given parameters
     */
    var triggerEvent = function (event, param1, param2, param3, param4) {
        eventHandlers[event].forEach(function (handler) {
            // Separate the context when calling the handler
            // This is to make sure that error in one handler doesn't stop other handlers
            (function () {
                handler(param1, param2, param3, param4);
            })();
        })
    };
};

// Constants
AMSAPI.APPLICANTS = "Applicant";
AMSAPI.PROCEED = "Proceed";
AMSAPI.INTERVIEW = "Interview";
AMSAPI.SECOND_INTERVIEW = "secondInterview";
AMSAPI.HIRED = "Hired";
AMSAPI.PASSED = "Passed";
AMSAPI.OFFER = "Offer";
AMSAPI.ONBOARDING = "OnBoard";
AMSAPI.RIGHT_TO_WORK = "RightToWork";
AMSAPI.TRUST_ID = "TrustId";
AMSAPI.KEESING = "Keesing";
AMSAPI.TALENT_CENTRAL = "TalentCentral";
AMSAPI.SCREENING_STAGE_2 = "ScreeningStage-2";
AMSAPI.SCREENING_STAGE_3 = "ScreeningStage-3";
AMSAPI.THRIVE_MAP = "ThriveMap";
AMSAPI.OUTMATCH = "Outmatch";
AMSAPI.CHEMISTRY = "Chemistry";
AMSAPI.READY_TO_OFFER = "ReadyToOffer";
AMSAPI.VIDEO_INTERVIEW = "videoInterview";
AMSAPI.BACKGROUND_CHECK = "backgroundCheck";
AMSAPI.PRE_HIRE = "Pre-Hire";
AMSAPI.APPLICANTS_AUTO_IMPORT = "ApplicantsAutoImport";
AMSAPI.GENERIC_LOCATION = "all";

AMSAPI.IDS = {
    "1": AMSAPI.APPLICANTS,
    "2": AMSAPI.PROCEED,
    "3": AMSAPI.INTERVIEW,
    "4": AMSAPI.HIRED,
    "5": AMSAPI.PASSED,
    "6": AMSAPI.OFFER,
    "7": AMSAPI.ONBOARDING,
    "8": AMSAPI.CUSTOM,
    "9": AMSAPI.RIGHT_TO_WORK
};

AMSAPI.CUSTOM_TYPE = 'CUSTOM';

AMSAPI.SYSTEM_BUCKET_WITH_CUSTOM_TYPE = [
    AMSAPI.KEESING,
    AMSAPI.TRUST_ID,
    AMSAPI.TALENT_CENTRAL,
    AMSAPI.SCREENING_STAGE_2,
    AMSAPI.SCREENING_STAGE_3,
    AMSAPI.THRIVE_MAP,
    AMSAPI.OUTMATCH,
    AMSAPI.CHEMISTRY,
    AMSAPI.READY_TO_OFFER,
    AMSAPI.VIDEO_INTERVIEW,
    AMSAPI.SECOND_INTERVIEW,
    AMSAPI.BACKGROUND_CHECK,
    AMSAPI.PRE_HIRE,
    AMSAPI.APPLICANTS_AUTO_IMPORT
];

AMSAPI.DEFAULT_BUCKET = {
    PASSED: {
        weight: 1000,
        location: "all"
    }
}